import PersonalNotification from "../entities/personalNotification";
import ChatNotification from "../entities/chatNotification";

export function isPersonalNotification(notif: PersonalNotification | ChatNotification): notif is PersonalNotification {
    return notif.hasOwnProperty("kind");
}